import { useQuery } from "@tanstack/react-query";
import { cachePolicyMs } from "../services/queries/cachePolicy";
import { fetchMediaTranslation } from "../services/media/mediaTranslationService";

export function useMediaTranslation(assetId: string | null) {
  return useQuery({
    queryKey: ["media-translation", assetId],
    queryFn: () => fetchMediaTranslation(assetId ?? ""),
    enabled: Boolean(assetId),
    staleTime: cachePolicyMs.intervieweeDetail,
  });
}
